<template>
  <div class="wrapper-page">
    <div class="flex flex-col h-full w-full gap-8">
      <div class="flex justify-between gap-5">
        <div>
          <h3 class="text-lg font-semibold text-foreground">
            {{ $t("Все дочерние элементы") }} ({{ total }})
          </h3>
        </div>
        <Button variant="default" @click="$emit('add-child', selectedItem)">
          <svg-icon name="huge-plus" class="w-5 h-5" />
          {{ $t("Добавить дочерний") }}
        </Button>
      </div>

      <div class="table-area">
        <div class="h-full overflow-auto">
          <Table :loading="loading" :scroll-reset-key="pagination.page">
            <TableHeader>
              <TableRow>
                <TableHead class="w-[220px]">{{ $t("Код") }}</TableHead>
                <TableHead class="min-w-[200px]">{{
                  $t("Название")
                }}</TableHead>
                <TableHead class="w-[140px]">{{ $t("Тип") }}</TableHead>
                <TableHead class="w-[160px]">{{ $t("Создан") }}</TableHead>
                <TableHead class="w-[140px]"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableEmpty v-if="!loading && !items.length" :colspan="5">
                {{ $t("Нет дочерних элементов") }}
              </TableEmpty>
              <TableRow
                v-for="row in items"
                :key="row.id"
                class="cursor-pointer"
                @click="handleRowClick(row)"
              >
                <TableCell>{{ row.code }}</TableCell>
                <TableCell>
                  <div class="flex flex-col gap-1">
                    <div class="text-foreground font-medium">
                      {{ getDisplayName(row) }}
                    </div>
                    <div
                      v-if="row.name_kz || row.name_en"
                      class="text-xs text-foreground"
                    >
                      {{ row.name_kz || row.name_en }}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <el-tag
                    v-if="row.is_subcategory"
                    type="success"
                    size="small"
                    class="!border-0 !rounded-full"
                  >
                    {{ $t("Подкатегория") }}
                  </el-tag>
                  <el-tag
                    v-else
                    type="info"
                    size="small"
                    class="!border-0 !rounded-full"
                  >
                    {{ $t("Значение") }}
                  </el-tag>
                </TableCell>
                <TableCell>{{ dateFormat(row.created_at) }}</TableCell>
                <TableCell>
                  <div class="flex items-center justify-center gap-1">
                    <button
                      class="p-2 hover:bg-muted rounded-lg"
                      @click.stop="$emit('edit', row)"
                      :title="$t('Редактировать')"
                    >
                      <svg-icon
                        name="huge-edit"
                        class="w-4 h-4 text-muted-foreground"
                      />
                    </button>
                    <button
                      class="p-2 hover:bg-muted rounded-lg"
                      @click.stop="$emit('delete', row)"
                      :title="$t('Удалить из справочника')"
                    >
                      <svg-icon
                        name="huge-danger"
                        class="w-4 h-4 text-red-400"
                      />
                    </button>

                    <button
                      class="p-2 hover:bg-muted rounded-lg"
                      @click.stop="$emit('exclude', row)"
                      :title="$t('Исключить из списка')"
                    >
                      <svg-icon
                        name="huge-close"
                        class="w-4 h-4 text-red-400"
                      />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableFooterWrapper from "@/shared/ui/custom/components/TableFooterWrapper.vue";
import dateFormat from "@/shared/lib/date-format";
import Button from "@/shared/ui/button/Button.vue";
import {
  Table,
  TableBody,
  TableCell,
  TableEmpty,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/ui/table";
export default {
  name: "DirectoryChildrenTable",

  components: {
    TableFooterWrapper,
    Button,
    Table,
    TableBody,
    TableCell,
    TableEmpty,
    TableHead,
    TableHeader,
    TableRow,
  },

  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 20,
      }),
    },
  },

  emits: ["row-click", "edit", "delete", "page-change", "add-child"],

  methods: {
    getDisplayName(item) {
      return (
        item.name ||
        item.name_kz ||
        item.name_en ||
        item.code ||
        this.$t("Без названия")
      );
    },

    dateFormat(date) {
      if (!date) {
        return this.$t("Не указано");
      }
      return dateFormat.timestamp_to_local_tz(date, "DD MMM YYYY, HH:mm");
    },

    handleRowClick(row) {
      this.$emit("row-click", row);
    },

    handleNavigate(row) {
      this.$emit("row-click", row);
    },

    handlePageChange(page) {
      this.$emit("page-change", page);
    },
  },
};
</script>

<style scoped lang="scss"></style>
